import { Helmet } from 'react-helmet-async';

const Meta = ({
  title = 'Welcome To Needs 4 Home',
  description = 'We sell the best products for cheap',
  keywords = 'home goods, deals',
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keyword" content={keywords} />
    </Helmet>
  );
};

export default Meta;